export default function EditarAzulButton({ onClick, size = 'md' }) {
  const isLarge = size === 'lg';

  return (
    <button
      type="button"
      onClick={onClick}
      className="flex items-center justify-center shrink-0 rounded-full border-none cursor-pointer touch-manipulation select-none transition-all duration-200 ease-out active:scale-[0.97] [@media(hover:hover)]:hover:bg-white/[0.85]"
      style={{
        height: isLarge ? '44px' : '40px',
        padding: isLarge ? '0 20px' : '0 18px',
        backgroundColor: '#fff',
        fontSize: '14px',
        fontWeight: 600,
        letterSpacing: '-0.01em',
        fontFamily: '"Public Sans", sans-serif',
        color: '#000',
      }}
    >
      Editar
    </button>
  );
}
